"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stubConfig = void 0;
__exportStar(require("./resolveConfigValue"), exports);
/*
 * ===========
 * re-usable config providers
 * ===========
 * */
/**
 * stub, mostly for testing. sometimes it helps please typescript to use this if you have
 * two configs you want to have the same type but one is a fixed string and one is a complicated provider
 *
 * @example const config = { configValue: stubConfig('just-a-string') };
 */
const stubConfig = (configValue) => configValue;
exports.stubConfig = stubConfig;
__exportStar(require("./envConfig"), exports);
__exportStar(require("./replaceConfig"), exports);
__exportStar(require("./awsParameterConfig"), exports);
__exportStar(require("./lambdaParameterConfig"), exports);
